
import authReducer from './reducers/authReducer'
import adminReducer from './reducers/adminReducer'
import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk'

const reducer = combineReducers({
    users: authReducer,
    admins: adminReducer
})
const store = createStore(reducer, applyMiddleware(thunk))

export default store;